import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { AddVehiclesService } from '../add-vehicles/add-vehicles.service';
import { PackageService } from '../package/package.service';
import { AddPackageService } from '../add-package/add-package.service';

@Component({
  selector: 'app-upload',
  templateUrl: './upload.component.html',
  styleUrls: ['./upload.component.sass']
})
export class UploadComponent implements OnInit {

  constructor(private toastr:ToastrService,
    private spinner :NgxSpinnerService,
    private avehicleService : AddVehiclesService,
    private packageService : AddPackageService,
    private router : Router) { }

  ngOnInit(): void {
  }


  vehicleFileReaded:any;
vehicleCsv_:any;

vehicleId:any='';
ownerContactName:any='';
ownerContactMobile:any='';
vehicleName:any='';
vehicleRegNo:any='';
vehicleType:any='';
vehicleCity:any;
vehicleSize:any='';
vehicleCapacity:any='';
vehicleOriginalPrice:any='';
vehicleDiscountPrice:any='';
vehicleRating:any='';
vehicleLabour:any='';
vehicleSharingmode:any=''


vehicleUploadStatus : any = false;
  getCSV_vehicle(event:any){
    this.vehicleMainData = [];
    if(  event.target.files[0].type  ==  "text/csv"  ){
    this.vehicleFileReaded = event.target.files[0];
    let reader: FileReader = new FileReader();
    reader.readAsText(this.vehicleFileReaded);
    reader.onload = (e) => {
      this.vehicleCsv_ = reader.result;
      let allTextLines = this.vehicleCsv_.split(/\r|\n|\r/);
      let headers = allTextLines[0].split(',');
      let lines :any = [];
  
      for (let i = 0; i < allTextLines.length; i++) {
        // split content based on comma
        let data = allTextLines[i].split(',');
        if (data.length === headers.length) {
          let tarr = [];
          for (let j = 0; j < headers.length; j++) {
            tarr.push(data[j]);
          }
          lines.push(tarr);
        }
      }

   this.manageCSVDATA_vehicle(lines)
  }  
  
  }else{
    this.toastr.warning('Please choose CSV file.')
  }
  
  }



  vehicleMainData:any='';
  manageCSVDATA_vehicle(lines=[]){
    this.vehicleUploadStatus = true
    this.vehicleMainData = [];
      for(let j =1; j < lines.length; j++ ){

        let data = {
          'vehicleContactName' : lines[j][0] ,
          'vehicleContactNumber' : lines[j][1] ,
          'vehicleName' : lines[j][2] ,
          'vehicleRegNo' : lines[j][3] ,
          'type' : lines[j][4] ,
          'vehicleCity' : lines[j][5] ,
          'vehicleState' : lines[j][6],
          'vehicleSize' : lines[j][7],
          'vehicleSizeDimention' : lines[j][8] ,
          'vehicleCapacity' : lines[j][9] ,
          'originalPrice' : lines[j][10] ,
          'discountedPrice' : lines[j][11] ,
          'rating' : lines[j][12] ,
          'labourAvailable' : lines[j][13] ,
          'sharingMode' : lines[j][14],
          'termsCondition' : lines[j][15],
        }
        this.vehicleMainData.push(data)       
      }
      console.log(this.vehicleMainData)

  }


  uploadVehicle(){
    console.log(this.vehicleMainData)

    this.avehicleService.addVehicleCSV(this.vehicleMainData).subscribe((result:any)=>{
      if(result.statusCode == 200){
        this.spinner.hide()
        this.toastr.success(result.message);
        this.router.navigateByUrl('dashboard/vehicle');
      }else{
        this.spinner.hide()
        this.toastr.error(result.message);
      }
    })

  }







  packageFileReaded:any;
  packageCsv_:any;

  packageUploadStatus : any = false;
    getCSV_package(event:any){
      this.packageMainData=[]
      if(  event.target.files[0].type  ==  "text/csv"  ){
      this.packageFileReaded = event.target.files[0];
      let reader: FileReader = new FileReader();
      reader.readAsText(this.packageFileReaded);
      reader.onload = (e) => {
        this.packageCsv_ = reader.result;
        let allTextLines = this.packageCsv_.split(/\r|\n|\r/);
        let headers = allTextLines[0].split(',');
        let lines :any = [];
    
        for (let i = 0; i < allTextLines.length; i++) {
          // split content based on comma
          let data = allTextLines[i].split(',');
          if (data.length === headers.length) {
            let tarr = [];
            for (let j = 0; j < headers.length; j++) {
              tarr.push(data[j]);
            }
            lines.push(tarr);
          }
        }
  
     this.manageCSVDATA_package(lines)
    }  
    
    }else{
      this.toastr.warning('Please choose CSV file.')
    }
    
    }
  
  
  
    packageMainData:any=''
    manageCSVDATA_package(lines=[]){
      this.packageUploadStatus = true;
      this.packageMainData=[];
        for(let j =1; j < lines.length; j++ ){
          let data = {
            'senderName'  : lines[j][0] ,
          'receiverName'  : lines[j][1] ,
          'senderMobile'  : lines[j][2] ,
          'receiverMobile'  : lines[j][3] ,
          'specialInstruction'  : lines[j][4] ,
          'senderEmail'  : lines[j][5] ,
          'receiverEmail'  : lines[j][6] ,
          'senderAddress'  : lines[j][7] ,
          'receiverAddress'  : lines[j][8] ,
          'noOfPackages'  : lines[j][9] ,
          'distance'  : lines[j][10] ,
          'shipmenType'  : lines[j][11] ,
          'packageDesc'  : lines[j][12] ,
          'deliveryPrice'  : lines[j][13] ,
          'weight'  : lines[j][14] ,
          'driverTip'  : lines[j][15] ,
        }
        this.packageMainData.push(data);
        }  
        console.log(this.packageMainData)
    }
  
  
    uploadPackage(){
      console.log(this.packageMainData);

      this.packageService.addPackageCSV(this.packageMainData).subscribe((result:any)=>{
        if(result.statusCode == 200){
          this.spinner.hide()
          this.toastr.success(result.message);
          this.router.navigateByUrl('dashboard/package');
        }else{
          this.spinner.hide()
          this.toastr.error(result.message);
        }
      })

    }


}
